import { AppModule } from './app/app.module';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

if (environment.production) {
  enableProdMode();
}

const loadScript = async () => {
  const script = document.createElement('script');

  const response = await fetch(`${environment.API_BASE_URL}/config`);
  const config = await response.json();

  script.type = "text/javascript";
  script.innerHTML = `
    var _paq = window._paq = window._paq || [];
    _paq.push(['enableLinkTracking']);
    _paq.push(['setLinkTrackingTimer', 750]);
    _paq.push(['alwaysUseSendBeacon']);
    (function () {
      var u = "${config.TelemetrySiteUrl}";
      _paq.push(['setTrackerUrl', u + 'matomo.php']);
      _paq.push(['setSiteId', ${config.TelemetrySiteId}]);
      var d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
      g.type = 'text/javascript'; g.async = false; g.src = '//cdn.matomo.cloud/${config.TelemetryNameSpace}/matomo.js'; s.parentNode.insertBefore(g, s);
    })();`

  const head = document.getElementsByTagName('head')[0];
  if (head !== null && head !== undefined) {
    document.head.appendChild(script);
  }

  const appInsightsInstance = new ApplicationInsights({ config: {
    instrumentationKey: config.appinsightsInstrumentationkey,
    enableAutoRouteTracking: true
  } });
  appInsightsInstance.loadAppInsights();
  (window as any).appInsights = appInsightsInstance;

}

loadScript()
  .then(() => platformBrowserDynamic().bootstrapModule(AppModule))
  .catch(err => console.error(err));
